import * as Mod1 from "./discourse/admin-discourse-ai-plugin-route-map";
import * as Mod2 from "./discourse/admin/adapters/ai-agent";
import * as Mod3 from "./discourse/admin/adapters/ai-decision-model";
import * as Mod4 from "./discourse/admin/adapters/ai-embedding";
import * as Mod5 from "./discourse/admin/adapters/ai-feature";
import * as Mod6 from "./discourse/admin/adapters/ai-llm";
import * as Mod7 from "./discourse/admin/adapters/ai-mcp-server";
import * as Mod8 from "./discourse/admin/adapters/ai-secret";
import * as Mod9 from "./discourse/admin/adapters/ai-tool";
import * as Mod10 from "./discourse/admin/models/ai-agent";
import * as Mod11 from "./discourse/admin/models/ai-decision-model";
import * as Mod12 from "./discourse/admin/models/ai-embedding";
import * as Mod13 from "./discourse/admin/models/ai-feature";
import * as Mod14 from "./discourse/admin/models/ai-llm";
import * as Mod15 from "./discourse/admin/models/ai-mcp-server";
import * as Mod16 from "./discourse/admin/models/ai-secret";
import * as Mod17 from "./discourse/admin/models/ai-tool";
import * as Mod18 from "./discourse/artifact-shares-route-map";
import * as Mod19 from "./discourse/components/admin-report-emotion";
import * as Mod20 from "./discourse/components/ai-agent-example";
import * as Mod21 from "./discourse/components/ai-agent-llm-selector";
import * as Mod22 from "./discourse/components/ai-agent-tool-options";
import * as Mod23 from "./discourse/components/ai-artifact-node-view";
import * as Mod24 from "./discourse/components/ai-artifact-share";
import * as Mod25 from "./discourse/components/ai-artifact";
import * as Mod26 from "./discourse/components/ai-blinking-animation";
import * as Mod27 from "./discourse/components/ai-bot-anonymous-card";
import * as Mod28 from "./discourse/components/ai-bot-chats-tab";
import * as Mod29 from "./discourse/components/ai-bot-conversations-layout";
import * as Mod30 from "./discourse/components/ai-bot-conversations-preview";
import * as Mod31 from "./discourse/components/ai-bot-conversations";
import * as Mod32 from "./discourse/components/ai-bot-docked-composer";
import * as Mod33 from "./discourse/components/ai-bot-header-icon";
import * as Mod34 from "./discourse/components/ai-bot-sidebar-empty-state";
import * as Mod35 from "./discourse/components/ai-bot-sidebar-new-conversation";
import * as Mod36 from "./discourse/components/ai-chat-model-label";
import * as Mod37 from "./discourse/components/ai-composer-helper-menu";
import * as Mod38 from "./discourse/components/ai-conversation-sidebar-context-menu";
import * as Mod39 from "./discourse/components/ai-credit-allocation-status";
import * as Mod40 from "./discourse/components/ai-credit-bar";
import * as Mod41 from "./discourse/components/ai-decoded-transcript";
import * as Mod42 from "./discourse/components/ai-discoveries-search-options";
import * as Mod43 from "./discourse/components/ai-feature-card";
import * as Mod44 from "./discourse/components/ai-features-list";
import * as Mod45 from "./discourse/components/ai-full-page-search";
import * as Mod46 from "./discourse/components/ai-gist-toggle";
import * as Mod47 from "./discourse/components/ai-helper-custom-prompt";
import * as Mod48 from "./discourse/components/ai-helper-loading";
import * as Mod49 from "./discourse/components/ai-helper-options-list";
import * as Mod50 from "./discourse/components/ai-indicator-wave";
import * as Mod51 from "./discourse/components/ai-llm-attachment-types";
import * as Mod52 from "./discourse/components/ai-llm-selector";
import * as Mod53 from "./discourse/components/ai-log-row";
import * as Mod54 from "./discourse/components/ai-mcp-server-editor-form";
import * as Mod55 from "./discourse/components/ai-mcp-server-editor";
import * as Mod56 from "./discourse/components/ai-payload-viewer";
import * as Mod57 from "./discourse/components/ai-post-helper-menu";
import * as Mod58 from "./discourse/components/ai-post-image-caption-editor-button";
import * as Mod59 from "./discourse/components/ai-quota-duration-selector";
import * as Mod60 from "./discourse/components/ai-regen-summaries-buttons";
import * as Mod61 from "./discourse/components/ai-search-discoveries";
import * as Mod62 from "./discourse/components/ai-search/ai-search-answer";
import * as Mod63 from "./discourse/components/ai-search/ai-search-conversation-references";
import * as Mod64 from "./discourse/components/ai-search/ai-search-references-panel";
import * as Mod65 from "./discourse/components/ai-search/ai-search-tabs";
import * as Mod66 from "./discourse/components/ai-search/ai-search-topic-row";
import * as Mod67 from "./discourse/components/ai-secret-editor-form";
import * as Mod68 from "./discourse/components/ai-secret-selector";
import * as Mod69 from "./discourse/components/ai-sentiment-horizontal-bar";
import * as Mod70 from "./discourse/components/ai-sharing-activity-tabs";
import * as Mod71 from "./discourse/components/ai-split-topic-suggester";
import * as Mod72 from "./discourse/components/ai-summary-skeleton";
import * as Mod73 from "./discourse/components/ai-tool-approval";
import * as Mod74 from "./discourse/components/ai-tool-editor-form";
import * as Mod75 from "./discourse/components/ai-tool-editor";
import * as Mod76 from "./discourse/components/ai-tool-selector";
import * as Mod77 from "./discourse/components/ai-topic-gist";
import * as Mod78 from "./discourse/components/bulk-actions/ai-regen-summaries";
import * as Mod79 from "./discourse/components/legacy-ai-search-discoveries-tooltip";
import * as Mod80 from "./discourse/components/legacy-ai-search-discoveries";
import * as Mod81 from "./discourse/components/modal/ai-agent-mcp-tool-selector-modal";
import * as Mod82 from "./discourse/components/modal/ai-agent-response-format-editor";
import * as Mod83 from "./discourse/components/modal/ai-artifact-options-modal";
import * as Mod84 from "./discourse/components/modal/ai-artifact-share-modal";
import * as Mod85 from "./discourse/components/modal/ai-llm-quota-modal";
import * as Mod86 from "./discourse/components/modal/ai-mcp-server-tools-modal";
import * as Mod87 from "./discourse/components/modal/ai-post-image-caption-editor";
import * as Mod88 from "./discourse/components/modal/ai-regen-summaries-modal";
import * as Mod89 from "./discourse/components/modal/ai-search-references-modal";
import * as Mod90 from "./discourse/components/modal/ai-secret-create-modal";
import * as Mod91 from "./discourse/components/modal/ai-summary-modal";
import * as Mod92 from "./discourse/components/modal/ai-theme-translation-modal";
import * as Mod93 from "./discourse/components/modal/ai-tool-test-modal";
import * as Mod94 from "./discourse/components/modal/chat-modal-channel-summary";
import * as Mod95 from "./discourse/components/modal/debug-ai-modal";
import * as Mod96 from "./discourse/components/modal/diff-modal";
import * as Mod97 from "./discourse/components/modal/rag-document-sources-modal";
import * as Mod98 from "./discourse/components/modal/share-full-topic-modal";
import * as Mod99 from "./discourse/components/modal/share-modal";
import * as Mod100 from "./discourse/components/modal/spam-test-modal";
import * as Mod101 from "./discourse/components/modal/thumbnail-suggestions";
import * as Mod102 from "./discourse/components/model-accuracies";
import * as Mod103 from "./discourse/components/post-menu/ai-cancel-streaming-button";
import * as Mod104 from "./discourse/components/post-menu/ai-debug-button";
import * as Mod105 from "./discourse/components/post-menu/ai-retry-streaming-button";
import * as Mod106 from "./discourse/components/post-menu/ai-share-button";
import * as Mod107 from "./discourse/components/post/ai-agent-flair";
import * as Mod108 from "./discourse/components/post/meta-data/ai-cancel-streaming";
import * as Mod109 from "./discourse/components/rag-document-sources";
import * as Mod110 from "./discourse/components/rag-options-fk";
import * as Mod111 from "./discourse/components/rag-upload-progress";
import * as Mod112 from "./discourse/components/rag-uploader";
import * as Mod113 from "./discourse/components/reviewable/ai-chat-message";
import * as Mod114 from "./discourse/components/reviewable/ai-post";
import * as Mod115 from "./discourse/components/reviewable/ai-tool-action";
import * as Mod116 from "./discourse/components/shared-artifacts-list";
import * as Mod117 from "./discourse/components/shared-conversations-list";
import * as Mod118 from "./discourse/components/suggestion-menus/ai-title-suggester";
import * as Mod119 from "./discourse/components/suggestion-menus/ai-title-suggestions-list";
import * as Mod120 from "./discourse/components/suggestion-menus/ai-title-suggestions-menu";
import * as Mod121 from "./discourse/components/thumbnail-suggestion-item";
import * as Mod122 from "./discourse/connectors/admin-customize-theme-translation-selector/ai-theme-translate.gjs";
import * as Mod123 from "./discourse/connectors/admin-dashboard-highlights-before-kpis/ai-admin-dashboard-highlight.gjs";
import * as Mod124 from "./discourse/connectors/after-d-editor/composer-open.gjs";
import * as Mod125 from "./discourse/connectors/after-filter-navigation-menu/filter-gist-toggle.gjs";
import * as Mod126 from "./discourse/connectors/after-search-result-entry/search-result-decoration.gjs";
import * as Mod127 from "./discourse/connectors/before-create-topic-button/topic-list-gist-toggle.gjs";
import * as Mod128 from "./discourse/connectors/composer-fields/agent-llm-selector.gjs";
import * as Mod129 from "./discourse/connectors/edit-topic-title__after/ai-title-suggestion.gjs";
import * as Mod130 from "./discourse/connectors/fast-edit-footer-after/ai-edit-suggestion-button.gjs";
import * as Mod131 from "./discourse/connectors/full-page-search-advanced-header/ai-full-page-search.gjs";
import * as Mod132 from "./discourse/connectors/full-page-search-before-results/ai-search-results-notice.gjs";
import * as Mod133 from "./discourse/connectors/full-page-search-below-search-header/ai-full-page-discobot-discoveries.gjs";
import * as Mod134 from "./discourse/connectors/full-page-search-below-search-header/legacy-ai-full-page-discobot-discoveries.gjs";
import * as Mod135 from "./discourse/connectors/post-menu-translations-dropdown/ai-post-menu-translation-extras.gjs";
import * as Mod136 from "./discourse/connectors/post-text-buttons/ai-post-helper-trigger.gjs";
import * as Mod137 from "./discourse/connectors/search-menu-before-advanced-search/ai-quick-search-loader.gjs";
import * as Mod138 from "./discourse/connectors/search-menu-results-bottom/ai-quick-search.gjs";
import * as Mod139 from "./discourse/connectors/search-menu-results-top/ai-discobot-discoveries.gjs";
import * as Mod140 from "./discourse/connectors/search-menu-results-top/ai-quick-search-info.gjs";
import * as Mod141 from "./discourse/connectors/search-menu-results-top/legacy-ai-discobot-discoveries.gjs";
import * as Mod142 from "./discourse/connectors/search-menu-results-type-top/ai-quick-search-notice.gjs";
import * as Mod143 from "./discourse/connectors/split-new-topic-category-after/ai-category-suggestion.gjs";
import * as Mod144 from "./discourse/connectors/split-new-topic-tag-after/ai-tag-suggestion.gjs";
import * as Mod145 from "./discourse/connectors/split-new-topic-title-after/ai-title-suggestion.gjs";
import * as Mod146 from "./discourse/connectors/topic-map-expanded-after/ai-summary-trigger.gjs";
import * as Mod147 from "./discourse/connectors/topic-map-participants-after/ai-conversation-invite.gjs";
import * as Mod148 from "./discourse/connectors/topic-map-participants-after/ai-search-conversation-references.gjs";
import * as Mod149 from "./discourse/connectors/topic-navigation/ai-search-conversation-references.gjs";
import * as Mod150 from "./discourse/connectors/user-messages-controls-bottom/pm-list-gist-toggle.gjs";
import * as Mod151 from "./discourse/connectors/user-preferences-interface/ai-ask-ai-default.gjs";
import * as Mod152 from "./discourse/connectors/user-preferences-interface/ai-search-discoveries.gjs";
import * as Mod153 from "./discourse/controllers/discourse-ai-bot-conversations";
import * as Mod154 from "./discourse/discourse-ai-bot-dashboard-route-map";
import * as Mod155 from "./discourse/discourse-ai-shared-conversation-show-route-map";
import * as Mod156 from "./discourse/initializers/add-ai-bot-to-community-section";
import * as Mod157 from "./discourse/initializers/admin-plugin-configuration-nav";
import * as Mod158 from "./discourse/initializers/ai-artifact-rich-editor";
import * as Mod159 from "./discourse/initializers/ai-artifact-shares";
import * as Mod160 from "./discourse/initializers/ai-artifacts";
import * as Mod161 from "./discourse/initializers/ai-bot-draft-icon";
import * as Mod162 from "./discourse/initializers/ai-bot-pm";
import * as Mod163 from "./discourse/initializers/ai-bot-replies";
import * as Mod164 from "./discourse/initializers/ai-category-chooser-inline-suggester";
import * as Mod165 from "./discourse/initializers/ai-chat-summarization";
import * as Mod166 from "./discourse/initializers/ai-conversations-sidebar";
import * as Mod167 from "./discourse/initializers/ai-gist-connector";
import * as Mod168 from "./discourse/initializers/ai-gist-topic-list-class";
import * as Mod169 from "./discourse/initializers/ai-helper";
import * as Mod170 from "./discourse/initializers/ai-post-image-caption-editor";
import * as Mod171 from "./discourse/initializers/ai-reviewable-status";
import * as Mod172 from "./discourse/initializers/ai-search-discoveries";
import * as Mod173 from "./discourse/initializers/ai-semantic-search";
import * as Mod174 from "./discourse/initializers/ai-sentiment-admin-nav";
import * as Mod175 from "./discourse/initializers/ai-tag-chooser-inline-suggester";
import * as Mod176 from "./discourse/initializers/ai-thinking";
import * as Mod177 from "./discourse/initializers/ai-tool-approval";
import * as Mod178 from "./discourse/initializers/ai-translation-topic-admin";
import * as Mod179 from "./discourse/initializers/related-topics";
import * as Mod180 from "./discourse/initializers/translation";
import * as Mod181 from "./discourse/lib/ai-artifact-embed";
import * as Mod182 from "./discourse/lib/ai-artifact-rich-editor-extension";
import * as Mod183 from "./discourse/lib/ai-bot-conversation-draft";
import * as Mod184 from "./discourse/lib/ai-bot-helper";
import * as Mod185 from "./discourse/lib/ai-errors";
import * as Mod186 from "./discourse/lib/ai-feature-setting-groups";
import * as Mod187 from "./discourse/lib/ai-follow-up";
import * as Mod188 from "./discourse/lib/ai-helper-suggestions";
import * as Mod189 from "./discourse/lib/ai-search-cited-topics";
import * as Mod190 from "./discourse/lib/ai-search-intent";
import * as Mod191 from "./discourse/lib/ai-search-references";
import * as Mod192 from "./discourse/lib/ai-search-scope";
import * as Mod193 from "./discourse/lib/ai-streamer/progress-handlers";
import * as Mod194 from "./discourse/lib/ai-streamer/updaters/post-updater";
import * as Mod195 from "./discourse/lib/ai-streamer/updaters/stream-updater";
import * as Mod196 from "./discourse/lib/ai-topic-summary";
import * as Mod197 from "./discourse/lib/ai-usage-time-series";
import * as Mod198 from "./discourse/lib/chooser-suggestion-context";
import * as Mod199 from "./discourse/lib/copy-conversation";
import * as Mod200 from "./discourse/lib/decoded-response";
import * as Mod201 from "./discourse/lib/decorate-ai-thinking";
import * as Mod202 from "./discourse/lib/diff-streamer";
import * as Mod203 from "./discourse/lib/full-page-search-types";
import * as Mod204 from "./discourse/lib/llm-provider-param-helpers";
import * as Mod205 from "./discourse/lib/open-topic-from-query";
import * as Mod206 from "./discourse/lib/post-image-caption-editor";
import * as Mod207 from "./discourse/lib/search-discoveries-context";
import * as Mod208 from "./discourse/lib/shortcut-label";
import * as Mod209 from "./discourse/lib/show-ai-helper";
import * as Mod210 from "./discourse/lib/smooth-streamer";
import * as Mod211 from "./discourse/lib/utilities";
import * as Mod212 from "./discourse/pre-initializers/ai-spam-transformers";
import * as Mod213 from "./discourse/routes/discourse-ai-bot-conversations";
import * as Mod214 from "./discourse/routes/discourse-ai-shared-conversation-show";
import * as Mod215 from "./discourse/routes/user-activity/shared-ai-artifacts";
import * as Mod216 from "./discourse/routes/user-activity/shared-ai-conversations";
import * as Mod217 from "./discourse/routes/user-activity/shared-artifacts";
import * as Mod218 from "./discourse/services/ai-bot-conversations-hidden-submit";
import * as Mod219 from "./discourse/services/ai-bot-docked-submit";
import * as Mod220 from "./discourse/services/ai-bot-streaming-state";
import * as Mod221 from "./discourse/services/ai-conversations-sidebar-manager";
import * as Mod222 from "./discourse/services/ai-credits";
import * as Mod223 from "./discourse/services/ai-search-session";
import * as Mod224 from "./discourse/services/discobot-discoveries";
import * as Mod225 from "./discourse/services/gists";
import * as Mod226 from "./discourse/services/legacy-discobot-discoveries";
import * as Mod227 from "./discourse/services/post-image-caption-editor";
import * as Mod228 from "./discourse/services/quick-search";
import * as Mod229 from "./discourse/templates/discourse-ai-bot-conversations";
import * as Mod230 from "./discourse/templates/user-activity/shared-ai-artifacts";
import * as Mod231 from "./discourse/templates/user-activity/shared-ai-conversations";
import * as Mod232 from "./lib/discourse-markdown/ai-tags";
import * as Mod233 from "./lib/discourse-markdown/ai-tool-approval";
const compatModules = {
  "discourse/admin-discourse-ai-plugin-route-map": Mod1,
  "discourse/admin/adapters/ai-agent": Mod2,
  "discourse/admin/adapters/ai-decision-model": Mod3,
  "discourse/admin/adapters/ai-embedding": Mod4,
  "discourse/admin/adapters/ai-feature": Mod5,
  "discourse/admin/adapters/ai-llm": Mod6,
  "discourse/admin/adapters/ai-mcp-server": Mod7,
  "discourse/admin/adapters/ai-secret": Mod8,
  "discourse/admin/adapters/ai-tool": Mod9,
  "discourse/admin/models/ai-agent": Mod10,
  "discourse/admin/models/ai-decision-model": Mod11,
  "discourse/admin/models/ai-embedding": Mod12,
  "discourse/admin/models/ai-feature": Mod13,
  "discourse/admin/models/ai-llm": Mod14,
  "discourse/admin/models/ai-mcp-server": Mod15,
  "discourse/admin/models/ai-secret": Mod16,
  "discourse/admin/models/ai-tool": Mod17,
  "discourse/artifact-shares-route-map": Mod18,
  "discourse/components/admin-report-emotion": Mod19,
  "discourse/components/ai-agent-example": Mod20,
  "discourse/components/ai-agent-llm-selector": Mod21,
  "discourse/components/ai-agent-tool-options": Mod22,
  "discourse/components/ai-artifact-node-view": Mod23,
  "discourse/components/ai-artifact-share": Mod24,
  "discourse/components/ai-artifact": Mod25,
  "discourse/components/ai-blinking-animation": Mod26,
  "discourse/components/ai-bot-anonymous-card": Mod27,
  "discourse/components/ai-bot-chats-tab": Mod28,
  "discourse/components/ai-bot-conversations-layout": Mod29,
  "discourse/components/ai-bot-conversations-preview": Mod30,
  "discourse/components/ai-bot-conversations": Mod31,
  "discourse/components/ai-bot-docked-composer": Mod32,
  "discourse/components/ai-bot-header-icon": Mod33,
  "discourse/components/ai-bot-sidebar-empty-state": Mod34,
  "discourse/components/ai-bot-sidebar-new-conversation": Mod35,
  "discourse/components/ai-chat-model-label": Mod36,
  "discourse/components/ai-composer-helper-menu": Mod37,
  "discourse/components/ai-conversation-sidebar-context-menu": Mod38,
  "discourse/components/ai-credit-allocation-status": Mod39,
  "discourse/components/ai-credit-bar": Mod40,
  "discourse/components/ai-decoded-transcript": Mod41,
  "discourse/components/ai-discoveries-search-options": Mod42,
  "discourse/components/ai-feature-card": Mod43,
  "discourse/components/ai-features-list": Mod44,
  "discourse/components/ai-full-page-search": Mod45,
  "discourse/components/ai-gist-toggle": Mod46,
  "discourse/components/ai-helper-custom-prompt": Mod47,
  "discourse/components/ai-helper-loading": Mod48,
  "discourse/components/ai-helper-options-list": Mod49,
  "discourse/components/ai-indicator-wave": Mod50,
  "discourse/components/ai-llm-attachment-types": Mod51,
  "discourse/components/ai-llm-selector": Mod52,
  "discourse/components/ai-log-row": Mod53,
  "discourse/components/ai-mcp-server-editor-form": Mod54,
  "discourse/components/ai-mcp-server-editor": Mod55,
  "discourse/components/ai-payload-viewer": Mod56,
  "discourse/components/ai-post-helper-menu": Mod57,
  "discourse/components/ai-post-image-caption-editor-button": Mod58,
  "discourse/components/ai-quota-duration-selector": Mod59,
  "discourse/components/ai-regen-summaries-buttons": Mod60,
  "discourse/components/ai-search-discoveries": Mod61,
  "discourse/components/ai-search/ai-search-answer": Mod62,
  "discourse/components/ai-search/ai-search-conversation-references": Mod63,
  "discourse/components/ai-search/ai-search-references-panel": Mod64,
  "discourse/components/ai-search/ai-search-tabs": Mod65,
  "discourse/components/ai-search/ai-search-topic-row": Mod66,
  "discourse/components/ai-secret-editor-form": Mod67,
  "discourse/components/ai-secret-selector": Mod68,
  "discourse/components/ai-sentiment-horizontal-bar": Mod69,
  "discourse/components/ai-sharing-activity-tabs": Mod70,
  "discourse/components/ai-split-topic-suggester": Mod71,
  "discourse/components/ai-summary-skeleton": Mod72,
  "discourse/components/ai-tool-approval": Mod73,
  "discourse/components/ai-tool-editor-form": Mod74,
  "discourse/components/ai-tool-editor": Mod75,
  "discourse/components/ai-tool-selector": Mod76,
  "discourse/components/ai-topic-gist": Mod77,
  "discourse/components/bulk-actions/ai-regen-summaries": Mod78,
  "discourse/components/legacy-ai-search-discoveries-tooltip": Mod79,
  "discourse/components/legacy-ai-search-discoveries": Mod80,
  "discourse/components/modal/ai-agent-mcp-tool-selector-modal": Mod81,
  "discourse/components/modal/ai-agent-response-format-editor": Mod82,
  "discourse/components/modal/ai-artifact-options-modal": Mod83,
  "discourse/components/modal/ai-artifact-share-modal": Mod84,
  "discourse/components/modal/ai-llm-quota-modal": Mod85,
  "discourse/components/modal/ai-mcp-server-tools-modal": Mod86,
  "discourse/components/modal/ai-post-image-caption-editor": Mod87,
  "discourse/components/modal/ai-regen-summaries-modal": Mod88,
  "discourse/components/modal/ai-search-references-modal": Mod89,
  "discourse/components/modal/ai-secret-create-modal": Mod90,
  "discourse/components/modal/ai-summary-modal": Mod91,
  "discourse/components/modal/ai-theme-translation-modal": Mod92,
  "discourse/components/modal/ai-tool-test-modal": Mod93,
  "discourse/components/modal/chat-modal-channel-summary": Mod94,
  "discourse/components/modal/debug-ai-modal": Mod95,
  "discourse/components/modal/diff-modal": Mod96,
  "discourse/components/modal/rag-document-sources-modal": Mod97,
  "discourse/components/modal/share-full-topic-modal": Mod98,
  "discourse/components/modal/share-modal": Mod99,
  "discourse/components/modal/spam-test-modal": Mod100,
  "discourse/components/modal/thumbnail-suggestions": Mod101,
  "discourse/components/model-accuracies": Mod102,
  "discourse/components/post-menu/ai-cancel-streaming-button": Mod103,
  "discourse/components/post-menu/ai-debug-button": Mod104,
  "discourse/components/post-menu/ai-retry-streaming-button": Mod105,
  "discourse/components/post-menu/ai-share-button": Mod106,
  "discourse/components/post/ai-agent-flair": Mod107,
  "discourse/components/post/meta-data/ai-cancel-streaming": Mod108,
  "discourse/components/rag-document-sources": Mod109,
  "discourse/components/rag-options-fk": Mod110,
  "discourse/components/rag-upload-progress": Mod111,
  "discourse/components/rag-uploader": Mod112,
  "discourse/components/reviewable/ai-chat-message": Mod113,
  "discourse/components/reviewable/ai-post": Mod114,
  "discourse/components/reviewable/ai-tool-action": Mod115,
  "discourse/components/shared-artifacts-list": Mod116,
  "discourse/components/shared-conversations-list": Mod117,
  "discourse/components/suggestion-menus/ai-title-suggester": Mod118,
  "discourse/components/suggestion-menus/ai-title-suggestions-list": Mod119,
  "discourse/components/suggestion-menus/ai-title-suggestions-menu": Mod120,
  "discourse/components/thumbnail-suggestion-item": Mod121,
  "discourse/connectors/admin-customize-theme-translation-selector/ai-theme-translate": Mod122,
  "discourse/connectors/admin-dashboard-highlights-before-kpis/ai-admin-dashboard-highlight": Mod123,
  "discourse/connectors/after-d-editor/composer-open": Mod124,
  "discourse/connectors/after-filter-navigation-menu/filter-gist-toggle": Mod125,
  "discourse/connectors/after-search-result-entry/search-result-decoration": Mod126,
  "discourse/connectors/before-create-topic-button/topic-list-gist-toggle": Mod127,
  "discourse/connectors/composer-fields/agent-llm-selector": Mod128,
  "discourse/connectors/edit-topic-title__after/ai-title-suggestion": Mod129,
  "discourse/connectors/fast-edit-footer-after/ai-edit-suggestion-button": Mod130,
  "discourse/connectors/full-page-search-advanced-header/ai-full-page-search": Mod131,
  "discourse/connectors/full-page-search-before-results/ai-search-results-notice": Mod132,
  "discourse/connectors/full-page-search-below-search-header/ai-full-page-discobot-discoveries": Mod133,
  "discourse/connectors/full-page-search-below-search-header/legacy-ai-full-page-discobot-discoveries": Mod134,
  "discourse/connectors/post-menu-translations-dropdown/ai-post-menu-translation-extras": Mod135,
  "discourse/connectors/post-text-buttons/ai-post-helper-trigger": Mod136,
  "discourse/connectors/search-menu-before-advanced-search/ai-quick-search-loader": Mod137,
  "discourse/connectors/search-menu-results-bottom/ai-quick-search": Mod138,
  "discourse/connectors/search-menu-results-top/ai-discobot-discoveries": Mod139,
  "discourse/connectors/search-menu-results-top/ai-quick-search-info": Mod140,
  "discourse/connectors/search-menu-results-top/legacy-ai-discobot-discoveries": Mod141,
  "discourse/connectors/search-menu-results-type-top/ai-quick-search-notice": Mod142,
  "discourse/connectors/split-new-topic-category-after/ai-category-suggestion": Mod143,
  "discourse/connectors/split-new-topic-tag-after/ai-tag-suggestion": Mod144,
  "discourse/connectors/split-new-topic-title-after/ai-title-suggestion": Mod145,
  "discourse/connectors/topic-map-expanded-after/ai-summary-trigger": Mod146,
  "discourse/connectors/topic-map-participants-after/ai-conversation-invite": Mod147,
  "discourse/connectors/topic-map-participants-after/ai-search-conversation-references": Mod148,
  "discourse/connectors/topic-navigation/ai-search-conversation-references": Mod149,
  "discourse/connectors/user-messages-controls-bottom/pm-list-gist-toggle": Mod150,
  "discourse/connectors/user-preferences-interface/ai-ask-ai-default": Mod151,
  "discourse/connectors/user-preferences-interface/ai-search-discoveries": Mod152,
  "discourse/controllers/discourse-ai-bot-conversations": Mod153,
  "discourse/discourse-ai-bot-dashboard-route-map": Mod154,
  "discourse/discourse-ai-shared-conversation-show-route-map": Mod155,
  "discourse/initializers/add-ai-bot-to-community-section": Mod156,
  "discourse/initializers/admin-plugin-configuration-nav": Mod157,
  "discourse/initializers/ai-artifact-rich-editor": Mod158,
  "discourse/initializers/ai-artifact-shares": Mod159,
  "discourse/initializers/ai-artifacts": Mod160,
  "discourse/initializers/ai-bot-draft-icon": Mod161,
  "discourse/initializers/ai-bot-pm": Mod162,
  "discourse/initializers/ai-bot-replies": Mod163,
  "discourse/initializers/ai-category-chooser-inline-suggester": Mod164,
  "discourse/initializers/ai-chat-summarization": Mod165,
  "discourse/initializers/ai-conversations-sidebar": Mod166,
  "discourse/initializers/ai-gist-connector": Mod167,
  "discourse/initializers/ai-gist-topic-list-class": Mod168,
  "discourse/initializers/ai-helper": Mod169,
  "discourse/initializers/ai-post-image-caption-editor": Mod170,
  "discourse/initializers/ai-reviewable-status": Mod171,
  "discourse/initializers/ai-search-discoveries": Mod172,
  "discourse/initializers/ai-semantic-search": Mod173,
  "discourse/initializers/ai-sentiment-admin-nav": Mod174,
  "discourse/initializers/ai-tag-chooser-inline-suggester": Mod175,
  "discourse/initializers/ai-thinking": Mod176,
  "discourse/initializers/ai-tool-approval": Mod177,
  "discourse/initializers/ai-translation-topic-admin": Mod178,
  "discourse/initializers/related-topics": Mod179,
  "discourse/initializers/translation": Mod180,
  "discourse/lib/ai-artifact-embed": Mod181,
  "discourse/lib/ai-artifact-rich-editor-extension": Mod182,
  "discourse/lib/ai-bot-conversation-draft": Mod183,
  "discourse/lib/ai-bot-helper": Mod184,
  "discourse/lib/ai-errors": Mod185,
  "discourse/lib/ai-feature-setting-groups": Mod186,
  "discourse/lib/ai-follow-up": Mod187,
  "discourse/lib/ai-helper-suggestions": Mod188,
  "discourse/lib/ai-search-cited-topics": Mod189,
  "discourse/lib/ai-search-intent": Mod190,
  "discourse/lib/ai-search-references": Mod191,
  "discourse/lib/ai-search-scope": Mod192,
  "discourse/lib/ai-streamer/progress-handlers": Mod193,
  "discourse/lib/ai-streamer/updaters/post-updater": Mod194,
  "discourse/lib/ai-streamer/updaters/stream-updater": Mod195,
  "discourse/lib/ai-topic-summary": Mod196,
  "discourse/lib/ai-usage-time-series": Mod197,
  "discourse/lib/chooser-suggestion-context": Mod198,
  "discourse/lib/copy-conversation": Mod199,
  "discourse/lib/decoded-response": Mod200,
  "discourse/lib/decorate-ai-thinking": Mod201,
  "discourse/lib/diff-streamer": Mod202,
  "discourse/lib/full-page-search-types": Mod203,
  "discourse/lib/llm-provider-param-helpers": Mod204,
  "discourse/lib/open-topic-from-query": Mod205,
  "discourse/lib/post-image-caption-editor": Mod206,
  "discourse/lib/search-discoveries-context": Mod207,
  "discourse/lib/shortcut-label": Mod208,
  "discourse/lib/show-ai-helper": Mod209,
  "discourse/lib/smooth-streamer": Mod210,
  "discourse/lib/utilities": Mod211,
  "discourse/pre-initializers/ai-spam-transformers": Mod212,
  "discourse/routes/discourse-ai-bot-conversations": Mod213,
  "discourse/routes/discourse-ai-shared-conversation-show": Mod214,
  "discourse/routes/user-activity/shared-ai-artifacts": Mod215,
  "discourse/routes/user-activity/shared-ai-conversations": Mod216,
  "discourse/routes/user-activity/shared-artifacts": Mod217,
  "discourse/services/ai-bot-conversations-hidden-submit": Mod218,
  "discourse/services/ai-bot-docked-submit": Mod219,
  "discourse/services/ai-bot-streaming-state": Mod220,
  "discourse/services/ai-conversations-sidebar-manager": Mod221,
  "discourse/services/ai-credits": Mod222,
  "discourse/services/ai-search-session": Mod223,
  "discourse/services/discobot-discoveries": Mod224,
  "discourse/services/gists": Mod225,
  "discourse/services/legacy-discobot-discoveries": Mod226,
  "discourse/services/post-image-caption-editor": Mod227,
  "discourse/services/quick-search": Mod228,
  "discourse/templates/discourse-ai-bot-conversations": Mod229,
  "discourse/templates/user-activity/shared-ai-artifacts": Mod230,
  "discourse/templates/user-activity/shared-ai-conversations": Mod231,
  "lib/discourse-markdown/ai-tags": Mod232,
  "lib/discourse-markdown/ai-tool-approval": Mod233,
};
export { compatModules };
export default compatModules;
